import React from 'react';
import CssBaseline from '@material-ui/core/CssBaseline';
import i18n from 'i18n';
import { I18nextProvider } from 'react-i18next';
import { GoogleOAuthProvider } from '@react-oauth/google';
import Provider from 'react-redux/es/components/Provider';
import { persistStore } from 'redux-persist';
import { PersistGate } from 'redux-persist/es/integration/react';
import config from 'config';

import { BrowserRouter } from 'react-router-dom';
import { configureStore } from 'store/configureStore';
import CustomThemeProvider from '../CustomThemeProvider';
import AppCssBaseline from '../AppCssBaseline';
import AppLayout from '../AppLayout';

export const store = configureStore();
let persistor = persistStore(store);

const App = () => (
  <I18nextProvider i18n={i18n}>
    <GoogleOAuthProvider clientId={config.GOOGLE_OAUTH.CLIENT_ID}>
      <Provider store={store}>
        <PersistGate persistor={persistor}>
          <BrowserRouter basename={config.HUB_PREFIX}>
            <CustomThemeProvider>
              <AppCssBaseline>
                <CssBaseline />
                <AppLayout />
              </AppCssBaseline>
            </CustomThemeProvider>
          </BrowserRouter>
        </PersistGate>
      </Provider>
    </GoogleOAuthProvider>
  </I18nextProvider>
);

export default App;
